var map = {
	"././pages/home/home.module": [
		"99Un",
		8
	],
	"././pages/login/login.module": [
		"F4UR",
		0,
		7
	],
	"././pages/profile-settings/profile-settings.module": [
		"tr+W",
		0,
		6
	],
	"././pages/receive/receive.module": [
		"ecnB",
		4
	],
	"././pages/transactions/transactions.module": [
		"RMDf",
		1
	],
	"././pages/transfer/transfer.module": [
		"2Ofg",
		5
	],
	"././pages/users/users.module": [
		"+P1L",
		0,
		2
	],
	"././pages/verification/verification.module": [
		"f12M",
		3
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error('Cannot find module "' + req + '".');
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var module = __webpack_require__(ids[0]);
		return module;
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "crnd";
module.exports = webpackAsyncContext;